import { FlexBox, Typography, SPACING } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import { useCoachSummarizerModalStore } from "./useCoachSummarizerModalStore"
import { CloseButton } from "../../../../components/closeButton/CloseButton"
import SlideUpModal from "../../../../components/slideUpModal/SlideUpModal"
import { useCoachingStore } from "../../useCoachingStore"

export const CoachSummarizerModal = () => {
  const { isOpen, onClose } = useCoachSummarizerModalStore()
  const { selectedCoach } = useCoachingStore()
  const { t } = useTranslation()

  return (
    <SlideUpModal
      isOpen={isOpen}
      onClose={onClose}
      size="fit-content"
      backgroundType="overlay"
      zIndex={1000}
    >
      <CloseButton onClick={onClose} />
      <FlexBox
        direction="column"
        fullWidth
        gap={SPACING.space4}
        style={{ padding: SPACING.space3 }}
      >
        <Typography variant="bodyBold">
          {t("COACHING_SUMMARIZER_MORE_ABOUT", {
            name: selectedCoach?.user.name,
          })}
        </Typography>
        <FlexBox direction="column" gap={SPACING.space1}>
          <Typography variant="bodySmallBold">
            {t("COACHING_SUMMARIZER_WHY_FIT", {
              name: selectedCoach?.user.name,
            })}
          </Typography>

          <Typography variant="bodySmall">
            {selectedCoach?.match_reason_long}
          </Typography>
        </FlexBox>
        <FlexBox direction="column" gap={SPACING.space1}>
          <Typography variant="bodySmallBold">
            {t("COACHING_SUMMARIZER_ABOUT", { name: selectedCoach?.user.name })}
          </Typography>
          <Typography variant="bodySmall">{selectedCoach?.bio}</Typography>
        </FlexBox>
      </FlexBox>
    </SlideUpModal>
  )
}
